import CryptoJS from 'crypto-js';

class CryptoString {
  constructor(secretKey) {
    this.encoder = CryptoJS.enc.Utf8;
    this.secretKey = secretKey;
  }

  encrypt(value) {
    try {
      return CryptoJS.AES.encrypt(value, this.secretKey).toString();
    } catch (error) {
      console.log('CryptoString encrypt error', error);
      throw error;
    }
  }

  decrypt(encryptedValue) {
    try {
      var bytes = CryptoJS.AES.decrypt(encryptedValue, this.secretKey);
      return bytes.toString(this.encoder);
    } catch (error) {
      console.log('CryptoString encryptedText error', error);
      throw error;
    }
  }

  // #append = (text) => {
  //   const appendString = text + 'sdsd';
  //   return
  // }
}

export default CryptoString;
